import React, { useContext } from "react";
import "./IntentHistory.css";
import { SideMenu } from "../../../../components/sideMenu/SideMenu";
import Spinner from "../../../../components/spinner/Spinner";
import { IntentHistoryContext } from "../IntentHistoryView";
import RouteConstant from "../../../../constants/routesContent.json";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../../../components/alertComponent/AlertBox";

const IntentHistoryPage = ({ textContents }) => {
  const {
    setintentHistoryList,
    intentHistoryList,
    showAlert,
    setShowAlert,
    alertMessage,
    logout,
    showLogoutAlert,
    setShowLogoutAlert,
    logoutConstants,
    logoutAlertMessage,
    processStatus,
    apiStatus
  } = useContext(IntentHistoryContext);

  const navigate = useNavigate();

  return (
    <>
      <div className="mainContanerIntentHistory">
        <SideMenu />

        <div className="historyContainer">
          <div className="container">
            <div className="col-xl-12">
              <div className="intentHistoryText">
                {textContents.intentHistory}
              </div>
              {intentHistoryList.length > 0 ? (
                <div className="scrollbarHistoryListContaineer scrolBarStyle">
                  <div className="scrollbarHistoryListoverflow">
                    {intentHistoryList.map((hlist) => {
                      return (
                        <div className="historyItemDivision" key={hlist.intent_id}>
                          <div
                            className="historyItemList"
                            onClick={() =>
                              navigate(RouteConstant.INTENT_HISTORY+`/${RouteConstant.INTENT_HISTORY_DETAILS}`, {
                                state: hlist,
                              })
                            }
                          >
                            <div className="freightOrderAligment">
                              <div className="freightOrderItem">
                                <span className="freightOrderNumber">
                                  {textContents.freightOrderNo}
                                </span>
                                <span className="freightOrdervalue">
                                  {hlist.sap_id}
                                </span>
                              </div>
                              <div className="freightOrderItem">
                                <span className="freightOrderNumber">
                                  {textContents.source}
                                </span>
                                <span className="freightOrdervalue">
                                  {hlist.source_name}
                                </span>
                              </div>
                              <div className="freightOrderItem">
                                <span className="freightOrderNumber">
                                  {textContents.destination}
                                </span>
                                <span className="freightOrdervalue">
                                  {hlist.destination_name}
                                </span>
                              </div>
                              <div className="freightOrderItem">
                                <span className="freightOrderNumber">
                                  {textContents.vehicleType}
                                </span>
                                <span className="freightOrdervalue">
                                  {hlist.truck_type}
                                </span>
                              </div>
                              <div className="freightOrderItem">
                                <span className="freightOrderNumber">
                                  {textContents.bidTime}
                                </span>
                                <span className="freightOrdervalue">
                                  {hlist.requirement_date} {""}  {hlist.requirement_time}
                                </span>
                              </div>
                              <div className="freightOrderItem2">
                                <span className="statusText">
                                  {textContents.status}
                                </span>
                                <span
                                  className={
                                    hlist.intent_status == "Success"
                                      ? "statusTextActive"
                                      : hlist.intent_status == "Completed"
                                      ? "statusTextCompleted"
                                      : hlist.intent_status == "Active"
                                      ? "statusTextPending"
                                      : hlist.intent_status == "Reject"
                                      ? "statusTextReject"
                                      : "statusTextCancel"
                                  }
                                >
                                  { processStatus(hlist.intent_status) }
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="emptyContainer">
                  { apiStatus === 'fetching'  ? <Spinner /> : <div className="nodataText">No Data Found</div> }
                </div>
              )}
            </div>
            <AlertBox
              show={showAlert}
              setShow={setShowAlert}
              title={textContents.alert}
              alertMessage={alertMessage}
              buttonSubmitText={"LOGIN"}
              alertFunc={() => {
                logout();
              }}
            />
            <AlertBox
              show={showLogoutAlert}
              setShow={setShowLogoutAlert}
              title={logoutConstants.alert}
              alertMessage={logoutAlertMessage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default IntentHistoryPage;
